module.exports = __webpack_public_path__ + "assets/img/1_689.6170c55a.jpg";